<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            SETTINGS / Bank Accounts
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Setting Dashboard</el-button>
            </div>
          </div>
          <el-table
              max-height="600"
              :data="tableData"
              :empty-text="$t('general_noData')"
              style="width: 100%"
              @row-click="rowClick">
            <el-table-column
                label="DB Code"
                prop="code"
                width="100">
            </el-table-column>
            <el-table-column
                :label="$t('settings_accountThink_taxTypes_accountGroup')">
              <template slot-scope="scope">
                {{scope.row.group.name}}
              </template>
            </el-table-column>
            <el-table-column
                prop="parentName"
                label="Account">
            </el-table-column>
            <el-table-column
                prop="name"
                label="Sub-accounts">
            </el-table-column>
            <el-table-column
                label="Status">
              <template slot-scope="scope">
                {{scope.row.close ? 'Closed' : scope.row.active ? 'Active' : 'Inactive' }}
              </template>
            </el-table-column>
<!--            <el-table-column-->
<!--                width="200"-->
<!--                :label="$t('settings_accountThink_taxTypes_currentBalance')">-->
<!--              <template slot-scope="scope">-->
<!--                {{scope.row.bankAccount ? formatPrice(scope.row.bankAccount.currentBalance) : null}}-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                width="200"-->
<!--                :label="$t('settings_accountThink_taxTypes_openingBalance')">-->
<!--              <template slot-scope="scope">-->
<!--                {{scope.row.bankAccount ? formatPrice(scope.row.bankAccount.openingBalance) : null}}-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column
                width="100"
                align="center"
                :label="$t('settings_accountThink_taxTypes_currency')">
              <template slot-scope="scope">
                {{scope.row.currencycode}}
              </template>
            </el-table-column>
            <el-table-column
                :label="$t('settings_accountThink_taxTypes_createDate')"
                align="center"
                width="150">
              <template slot-scope="scope">
                {{moment(scope.row.createdDate).format('D MMM YY') }}
              </template>
            </el-table-column>
            <el-table-column
                width="120"
                column-key="operations"
                :label="$t('settings_accountThink_taxTypes_operations')">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="primary"
                    plain
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row)"></el-button>
                <el-button
                    size="mini"
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    @click="handleDelete(scope.$index, scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
          <edit-bank-account-modal
              ref="editBankAccountModal"
              @loadList="loadList"/>
          <settings-bank-account-info-modal
              ref="settingBankAccountInfoModal"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment'
import EditBankAccountModal from "@/components/settings/settingsBankAccounts/EditBankAccountModal";
import SettingsBankAccountInfoModal from "@/components/settings/settingsBankAccounts/settingsBankAccountInfoModal";

export default {
  name: "BankAccounts",
  components: {SettingsBankAccountInfoModal, EditBankAccountModal},
  data(){
    return {
      tableData: [],
      moment: moment
    }
  },
  mounted(){
    this.loadList()
  },
  methods: {
    loadList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/account/accountOnlyBank?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    handleEdit(index, row) {
      this.$refs.editBankAccountModal.openModal(row)
    },
    handleDelete(index, row) {
      console.log(index, row)
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    rowClick(row, column, event) {
      if (column.columnKey !== 'operations') {
        this.$refs.settingBankAccountInfoModal.openModal(row)
      }
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
  }
}
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
      .settings-header {
        display: flex;
        justify-content: space-between;
      }
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
/deep/.el-table__row {
  cursor: pointer;
}
</style>
